import {
  SET_PRODUCTS,
  SET_DISLIKED_PRODUCTS,
  DELETE_PRODUCT,
  SET_SUGGESTED_PRODUCTS,
  SET_PRODUCT_CATEGORIES,
} from '../actions/product';

let initialState = {
  productsData: [],
  categoriesData: [],
  dislikedProductsData: [],
  suggestedProductsData: [],
};

const product = (state = initialState, action) => {
  switch (action.type) {
    case SET_PRODUCTS:
      return {
        ...state,
        productsData: action.payload,
      };

    case SET_PRODUCT_CATEGORIES:
      return {
        ...state,
        categoriesData: action.payload,
      };

    case DELETE_PRODUCT: {
      const { productsData } = state;
      const newProductsData = productsData.filter((productData) => {
        return productData.id !== action.payload;
      });

      return {
        ...state,
        productsData: newProductsData,
      };
    }

    case SET_DISLIKED_PRODUCTS:
      return {
        ...state,
        dislikedProductsData: action.payload,
      };

    case SET_SUGGESTED_PRODUCTS:
      return {
        ...state,
        suggestedProductsData: action.payload,
      };

    default:
      return state;
  }
};

export default product;
